export enum Sfxs {
    Air = 'air',
    Aircraft = 'aircraft',
    Alarms = 'alarms',
    Ambience = 'ambience',
    Animals = 'animals',
    Archived = 'archived',
    Beeps = 'beeps',
    Bells = 'bells',
    Birds = 'birds',
    Boats = 'boats',
    Bullets = 'bullets',
    Cartoon = 'cartoon',
    Ceramics = 'ceramics',
    Chains = 'chains',
    Chemicals = 'chemicals',
    Clocks = 'clocks',
    Cloth = 'cloth',
    Communications = 'communications',
    Computers = 'computers',
    Creatures = 'creatures',
    Crowds = 'crowds',
    Designed = 'designed',
    Destruction = 'destruction',
    DirtSand = 'dirt_sand',
    Doors = 'doors',
    Drawers = 'drawers',
    Electricity = 'electricity',
    Equipment = 'equipment',
    Explosions = 'explosions',
    Farts = 'farts',
    Fight = 'fight',
    Fire = 'fire',
    Fireworks = 'fireworks',
    Foley = 'foley',
    FoodDrink = 'food_drink',
    Footsteps = 'footsteps',
    Games = 'games',
    Geothermal = 'geothermal',
    Glass = 'glass',
    Gore = 'gore',
    Guns = 'guns',
    Horns = 'horns',
    Human = 'human',
    Ice = 'ice',
    Lasers = 'lasers',
    Leather = 'leather',
    LiquidMud = 'liquid_mud',
    Machines = 'machines',
    Magic = 'magic',
    Mechanical = 'mechanical',
    Metal = 'metal',
    Motors = 'motors',
    Movement = 'movement',
    Musical = 'musical',
    NaturalDisaster = 'natural_disaster',
    Objects = 'objects',
    Paper = 'paper',
    Plastic = 'plastic',
    Rain = 'rain',
    Robots = 'robots',
    Rocks = 'rocks',
    Rope = 'rope',
    Rubber = 'rubber',
    SciFi = 'scifi',
    Snow = 'snow',
    Sports = 'sports',
    Swooshes = 'swooshes',
    Tools = 'tools',
    Toys = 'toys',
    Trains = 'trains',
    UserInterface = 'user_interface',
    Vegetation = 'vegetation',
    Vehicles = 'vehicles',
    Voices = 'voices',
    Water = 'water',
    Weapons = 'weapons',
    Weather = 'weather',
    Whistles = 'whistles',
    Wind = 'wind',
    Windows = 'windows',
    Wings = 'wings',
    Wood = 'wood',
}
